<template src="../template/reg_4.html"></template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { startToWatchGps, sendGeoLocation } from '../utils/geolocationUtil'

export default {
  name: 'Reg-4',
  computed: {
    ...mapState(['PROJECT_ID', 'QR_CODE', 'USER_GENDER', 'USER_AGE_RANGE']),
    ...mapGetters(['getProjectId', 'getQRCode', 'getUserGender', 'getUserAgeRange', 'getUserName'])
  },
  data: function () {
    return {
      userName: ''
    }
  },
  created: function () {
    if (window.localStorage.getItem('gpsTimeID') !== null) {
      clearInterval(parseInt(window.localStorage.getItem('gpsTimeID')))
      window.localStorage.removeItem('gpsTimeID')
    }
    startToWatchGps()
    sendGeoLocation(this.getProjectId, this.getQRCode, 'Reg-4')
    const timeoutID = window.setInterval(
      () => {
        sendGeoLocation(this.getProjectId, this.getQRCode, 'Reg-4')
      }, 15000
    )
    window.localStorage.setItem('gpsTimeID', timeoutID)
    if (_.isEmpty(this.getProjectId) || _.isEmpty(this.getQRCode)) {
      this.$swal({
        title: '找不到專案代碼與 QR Code',
        text: '系統將自動導至官網',
        type: 'error'
      }).then(function (result) {
        if (result.value) {
          window.location.href = window.localStorage.getItem('projectOfficialSite')
        }
      })
    }
  },
  methods: {
    ...mapMutations(['setUserName']),
    submit () {
      this.setUserName(this.userName)
      // let data = new FormData()
      // data.append('userId', window.localStorage.getItem('userId'))
      // data.append('gender', this.getUserGender)
      // data.append('ageRange', this.getUserAgeRange)
      // data.append('userName', decodeURI(this.userName))

      const data = { userId: window.localStorage.getItem('userId'),
        gender: this.getUserGender,
        ageRange: this.getUserAgeRange,
        userName: this.userName
      }

      const config = {
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }

      Vue.axios.post('https://api.y2services.com/v1/guideuser/update', this.Qs.stringify(data), config)
        .then((response) => {
        })
        .catch((e) => {
        })
      this.$router.push('exhibition')
    }
  }
}
</script>
